import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';

const styles = {
    container: {
        display: 'flex',
        flexDirection: 'column',
        textAlign: 'center',
        backgroundColor: '#0081C8',
        color: 'white',
    },
    title: {
        fontWeight: 'bold',
        fontSize: '20pt',
    },
}

const IENotSupportedPage = (props) => (
    <div  className={props.classes.container}>
        <p className={props.classes.title} >Your Browser is not supported.</p>
        <p> To use this site, please upgrade to the latest version of Chrome, Firefox, 
            Safari or Microsoft Edge.
        </p>
    </div>
);

IENotSupportedPage.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles, { withTheme: true })(IENotSupportedPage);



// WEBPACK FOOTER //
// ./src/IENotSupportedPage.js